export default __webpack_public_path__ + "static/media/Patch 2.91e04f35.png";